function checkIfClouldinaryUrl(url: string) {
    return url ? url.search("res.cloudinary.com") > 0 : false
}

const trimCloudinaryVideo = (url: string, config: { startTime: number, duration: number, quality: string }) => {
    const { startTime, duration, quality } = config;

    //TODO - handle defaults
    const checkConfig = !!(startTime || duration || quality);

    if (!checkConfig || !checkIfClouldinaryUrl(url)) return url;

    //TODO - todo to checkl number greater than 0
    const startVideo = startTime ? `so_${startTime}` : "so_0";
    const endVideoDuration = (startTime || 0) + duration + 1;
    const endVideo = `eo_${endVideoDuration}`;
    const qualityParam = `q_auto:${quality}`;
    const editParameters = duration ? `${endVideo},${startVideo}` : `${startVideo}`;

    const parts = url.split("/")
    const uploadParts = parts.indexOf("upload");

    //TODO - check should be only on edit parameters or quality param
    if (quality) {
        parts.splice(uploadParts + 1, 0, qualityParam)
    }
    if (startTime || duration) {
        parts.splice(uploadParts + 1, 0, editParameters)
    }
    const joinedParts = parts.join("/");

    const dotParts: string[] = joinedParts.split(".");
    const dotPartsShift: string[] = dotParts.reduce((cumulate: string[], part: string) => ["mp4", "webm"].includes(part) ? [...cumulate, "webm"] : [...cumulate, part], []);
    return dotPartsShift.join(".")
}

export default trimCloudinaryVideo;